import axios from '../../utils/axios';

export const getBlogAsync = async (id) => {
    const response = await axios.get(`/blogs/${id}`);
    return response.data;
}

export const saveUnSaveBlogAsync = async ({id, isSaved}) => {
    await axios.patch(`/blogs/${id}`, {
        isSaved: isSaved
    });
}

export const addLikeAsync = async ({id, likes}) => {
    await axios.patch(`/blogs/${id}`, {
        likes: likes + 1
    });
}
